import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';
export function sublimeInit(options) {
  var _ref = options || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'dark' : _ref$theme,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? [] : _ref$styles;
  return createTheme({
    theme: theme,
    settings: _extends({
      background: '#303841',
      foreground: '#FFFFFF',
      caret: '#FBAC52',
      selection: '#4C5964',
      selectionMatch: '#3A546E',
      gutterBackground: '#303841',
      gutterForeground: '#FFFFFF70',
      lineHighlight: '#00000059'
    }, settings),
    styles: [{
      tag: [t.meta, t.comment],
      color: '#A2A9B5'
    }, {
      tag: [t.attributeName, t.keyword],
      color: '#B78FBA'
    }, {
      tag: t.function(t.variableName),
      color: '#5AB0B0'
    }, {
      tag: [t.string, t.regexp, t.attributeValue],
      color: '#99C592'
    }, {
      tag: t.operator,
      color: '#f47954'
    },
    // { tag: t.moduleKeyword, color: 'red' },
    {
      tag: [t.tagName, t.modifier],
      color: '#E35F63'
    }, {
      tag: [t.number, t.definition(t.tagName), t.className, t.definition(t.variableName)],
      color: '#fbac52'
    }, {
      tag: [t.atom, t.bool, t.special(t.variableName)],
      color: '#E35F63'
    }, {
      tag: t.variableName,
      color: '#539ac4'
    }, {
      tag: [t.propertyName, t.typeName],
      color: '#629ccd'
    }, {
      tag: t.propertyName,
      color: '#36b7b5'
    }].concat(_toConsumableArray(styles))
  });
}
export var sublime = sublimeInit();